import { AdminAppState } from '../../state';
import { SiteViewportState } from '../../state/site-viewport';

export const getSiteViewportState = (state: AdminAppState): SiteViewportState =>
  state.viewport;
